<template>
  <ax-dialog
    ref="dialog"
    title="Transfer"
    icon="mdi-account-outline"
    @shown="onShow"
    @submitted="onSubmit"
  >
    <template slot="content">
      <v-card-text>
        <v-autocomplete label="Select user(s)" v-model="selected" :items="options" />
      </v-card-text>
    </template>
  </ax-dialog>
</template>
<script>
import AxDialog from "@/components/dialog"
import Users from '@/api/users'
import Files from '@/api/files'
import Datasets from '@/api/datasets'
import Predictions from '@/api/predictions'
import Exports from '@/api/exports'
export default {
  name: "Transfer",
  props: {
    mode: { type: String, required: true },
    item: { type: Object, required: true }
  },
  components: { AxDialog },
  data() {
    return {
      selected: null,
      options: [],
    }
  },
  methods: {
    onShow(shown) {
      if (shown) {
        Users.list().then(response => {
        this.options = response.data
                        .filter(u => u.username !== this.user.username)
                        .map(user => { return { text: user.name, value: user.id } })
        })
      } else {
        this.options = []
      }
    },
    onSubmit() {
      if (this.mode =='file') {
        Files.patch(this.item.uuid, { owner: this.selected}).then(_ => {
          this.$emit('transfer', true, `File transfered`)
          this.$router.push({ name: `${this.mode}List` })
        })
      } else if (this.mode == 'dataset') {
        Datasets.patch(this.item.uuid, { owner: this.selected}).then(_ => {
          this.$emit('transfer', true, `Dataset transfered`)
          this.$router.push({ name: `${this.mode}List` })
        })
      } else if (this.mode == 'prediction') {
        Predictions.patch(this.item.uuid, { owner: this.selected}).then(_ => {
          this.$emit('transfer', true, `Prediction transfered`)
          this.$router.push({ name: `${this.mode}List` })
        })
      } else if (this.mode == 'export') {
        Exports.patch(this.item.uuid, { owner: this.selected}).then(_ => {
          this.$emit('transfer', true, `Export transfered`)
          this.$router.push({ name: `${this.mode}List` })
        })
      }
    },
  }
}
</script>